import React from 'react';
import "./TabItem.scss";

const TabItem = props => <div className={'tab-item ' + (props.active ? 'tab-item--active ' : '') + (props.visible ? 'tab-item--visible' : '')}>&nbsp;</div>;

export default TabItem;
